import React from 'react';
import { Facebook, Mail, MapPin, Phone } from 'lucide-react';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-24 px-6 bg-white text-diwan-cream relative overflow-hidden border-t border-diwan-700">
      {/* Background decoration - lighter for light theme */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-diwan-gold/5 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between gap-16 relative z-10">
        
        <div className="md:w-1/2 space-y-10">
          <div>
            <h2 className="text-5xl md:text-7xl font-serif mb-6">Let's craft your <span className="text-diwan-gold italic">legacy.</span></h2>
            <p className="text-diwan-cream/60 font-sans max-w-md leading-relaxed">
              To experience the real quality, choice, and service D'mans offers, a visit to our Show Centre is highly recommended.
            </p>
          </div>

          <div className="space-y-6">
            <div className="flex items-start gap-4 group">
                <div className="p-3 bg-diwan-800 rounded-full group-hover:bg-diwan-gold transition-colors duration-300">
                    <MapPin size={20} className="text-diwan-gold group-hover:text-white" />
                </div>
                <div>
                    <h5 className="font-serif text-lg text-diwan-cream">Visit Us</h5>
                    <p className="text-diwan-cream/50 text-sm mt-1">11, Timber Market, Chandigarh 160 019 (India)</p>
                </div>
            </div>
            
            <div className="flex items-start gap-4 group">
                <div className="p-3 bg-diwan-800 rounded-full group-hover:bg-diwan-gold transition-colors duration-300">
                    <Phone size={20} className="text-diwan-gold group-hover:text-white" />
                </div>
                <div>
                    <h5 className="font-serif text-lg text-diwan-cream">Call Us</h5>
                    <p className="text-diwan-cream/50 text-sm mt-1">+91 172 2792511</p>
                </div>
            </div>

            <div className="flex items-start gap-4 group">
                <div className="p-3 bg-diwan-800 rounded-full group-hover:bg-diwan-gold transition-colors duration-300">
                    <Mail size={20} className="text-diwan-gold group-hover:text-white" />
                </div>
                <div>
                    <h5 className="font-serif text-lg text-diwan-cream">Email Us</h5>
                    <p className="text-diwan-cream/50 text-sm mt-1">info@dmans.in</p>
                </div>
            </div>
          </div>
          
          <div className="pt-8">
              <a href="https://facebook.com/ranbirsinghdhimanandsons" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-diwan-gold hover:text-diwan-cream transition-colors">
                  <Facebook size={16} />
                  facebook/ranbirsinghdhimanandsons
              </a>
          </div>
        </div>

        <div className="md:w-1/3 flex flex-col justify-between border-l border-diwan-700 pl-0 md:pl-12">
            <div className="space-y-8">
                <blockquote className="font-serif text-2xl italic text-diwan-cream/80 leading-relaxed">
                    "At D'mans, words such as quality, delivery, and styling are not merely slogans — they are an everyday approach."
                </blockquote>
                <div className="space-y-2">
                     {/* Signature Representation */}
                     <div className="font-handwriting text-4xl text-diwan-gold font-serif italic">Sukhjit S. Dhiman</div>
                     <p className="text-xs uppercase tracking-widest text-diwan-cream/40">C.E.O. D'mans (Ranbir Singh Dhiman & Sons)</p>
                </div>
            </div>
            
            <div className="mt-12">
                <button className="px-8 py-4 bg-transparent border border-diwan-gold text-diwan-gold hover:bg-diwan-gold hover:text-white transition-all duration-300 uppercase tracking-widest text-xs font-bold w-full md:w-auto">
                    Download Brochure
                </button>
            </div>
        </div>

      </div>
    </section>
  );
};

export default Contact;